export default function Goodbye() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
      <div className="max-w-sm text-center space-y-4">
        <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-stone-900" style={{ fontFamily: 'Outfit' }}>Thank you!</h1>
        <p className="text-sm text-stone-500">
          You can close this tab now. To return, please scan the QR code at your table again.
        </p>
      </div>
    </div>
  );
}
